export default __webpack_public_path__ + "static/media/abaya.89d112df.jpeg";